import { RootState } from "store";

export function selectMetadataJsonData(state: RootState) {
  return state.products.metadata.data;
}

export function selectMetadataGetting(state: RootState) {
  return state.products.metadata.getting;
}
